// extracted by mini-css-extract-plugin
export default {"InputIcon":"_InputIcon--dshoe","CustomOption":"_CustomOption--HZFXC"};